import { Autocomplete, Box, TextField } from "@mui/material";
import { Scope } from "../../../../common/const";

const CommonScope = ({
    val,
    onSelectChange,
}) => {
    return (
        <Box display="flex" gap={1} justifyContent="center">
            <Autocomplete
                value={Scope.find((c) => c.value === val) || null}
                id="combo-box-demo"
                size="small"
                clearIcon={null}
                options={Scope}
                getOptionLabel={(option) => option?.name}
                onChange={(event, newValue) => onSelectChange(event, newValue)}
                sx={{
                    width: '200px'
                }}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        label="Calculate Variant From"
                        name="Calculate Variant From"
                        variant="standard"
                        sx={{
                            '& .MuiInputBase-root': { fontSize: '0.85rem' },
                            '& .MuiInputLabel-root': { fontSize: '0.8rem' },
                        }}
                    />}
            />
        </Box>
    )
}

export default CommonScope;